module.exports = __webpack_public_path__ + "static/p11_back-cf6c9648296321db3f727c9ee5293d6b.jpg";